export const PriceTag = ({ product, className = "", testid, showPercent = true }) => {
  const price = Number(product?.price || 0);
  const original = Number(product?.original_price || 0);
  const onSale = original > price;
  return (
    <span data-testid={testid} className={`inline-flex items-baseline flex-wrap gap-x-1.5 ${className}`}>
      <span className={onSale ? "text-[#C8361B]" : ""}>€{price.toFixed(2)}</span>
      {onSale && (
        <>
          <s data-testid={testid ? `${testid}-original` : undefined} className="opacity-50 text-[0.8em] font-normal">€{original.toFixed(2)}</s>
          {showPercent && product.sale_percent ? (
            <span className="self-center font-badge text-[9px] tracking-[0.12em] bg-[#C8361B] text-white px-1.5 py-[1px] rounded-full leading-tight">
              -{product.sale_percent}%
            </span>
          ) : null}
        </>
      )}
    </span>
  );
};
